import React, { FC } from 'react'
import { InsuranceTopBarProps } from '../../../../Partials/InsuranceTopBar/InsuranceTopBarProps.csharp';
import { SvgIcon } from '../../../SvgIcon/SvgIcon';
import { StreamLineIcon } from "../../../SvgIcon/StreamLineIcon";
import { Link } from '../../Partials/Link';
import { ReportErrorBar } from './ReportError/ReportErrorBar';
import { InsuranceLabelsContext } from '../../Utils/Context/labelsContext';

export const TopBar: FC<InsuranceTopBarProps> = ({ tabItems, commonProps}) => {
  return (
    <InsuranceLabelsContext labels={commonProps.insuranceLabels} >
      <header>
        {commonProps.isAuthenticated && <ReportErrorBar />}
        <div className="insuranceTopBar">
          <Link className="insuranceTopBar__logo" href="/" type="button" buttonType="clear" buttonSize="small">
            <span className="visually-hidden">Volvat.no</span>
            <SvgIcon className="insuranceTopBar__logoIcon" iconName="logotype" />
          </Link>
          <ul className="insuranceTopBar__navigation">
            {tabItems.map((t, k) => (
              <li className="insuranceTopBar__navigationItem" key={k}>
                <Link href={t.link.url} type="button" buttonType={t.isActive ? 'solid' : 'clear'}>
                  {t.isLogoutTab && (
                    <StreamLineIcon className="insuranceTopBar__navigationItemIcon" iconName="s-logout" />
                    )}
                  {t.isLoginTab && (
                    <StreamLineIcon className="insuranceTopBar__navigationItemIcon" iconName="s-login" />
                  )}
                  <span>{t.link.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </header>
    </InsuranceLabelsContext>
  );
};
